import {
  blacklistStatusCode,
  CustomError,
  FetchInitType,
  FetchRequestInfoType,
} from './model/custom-fetch';

const customFetch = (url: FetchRequestInfoType, options?: FetchInitType) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<Response>(async (resolve, reject) => {
    try {
      const request = await fetch(url, options);

      if (!request.ok) {
        const errResponse = await request.json();
        reject(
          new CustomError(
            `[${request.status}] - ${request.statusText}`,
            !blacklistStatusCode.some(
              (statusCode) => statusCode === request.status,
            ),
            {
              ...errResponse,
              ...(!errResponse.status_code && { statusCode: request.status }),
            },
          ),
        );
      } else {
        resolve(request);
      }
    } catch (err) {
      const error = err as Error;
      if (error.name === 'AbortError')
        /**
         * Temporary allow retry on timeout exceeded
         */
        reject(new CustomError('Request Aborted - Timeout Exceeded', false));
      reject(new CustomError(error.message, false));
    }
  });
};

export default customFetch;
